import React, {Component} from 'react'
import PropTypes from 'prop-types';
import SearchCardContent from "./SearchCardContent";

export default class SearchCard extends Component
{
    static propTypes = {
        textInput: PropTypes.string
    };

    render() {
        const {textInput} = this.props;

        if(textInput.length>=1) {
            return(
                <div className='card' style={{'position': 'absolute', 'left': 0, 'right': 0, 'marginTop': '10px', 'overflowY': 'auto', 'maxHeight': '70vh'}}>
                    <div className='card-body'>
                        <SearchCardContent textInput={textInput}/>
                    </div>
                </div>
            )
        }

        return null
    }
}



// WEBPACK FOOTER //
// ./React/src/components/LabelSearch/SearchCard.js